import React from "react";
import { Button, Modal } from "design_system/src";
import { ReactComponent as Search } from "design_system/src/static/icons/search.svg";
import { SelectedSkuFilters, SkuFilterOptions } from "models/inventory/helpers/skuFilters.helpers";
import useSkus from "hooks/useSkus";
import SkuInputFilters from "./SkuInputFilters";

interface Props {
  count: number;
  open: boolean;
  setOpen: (open: boolean) => void;
  onChange: (changes: Partial<SelectedSkuFilters>) => void;
  onClearAll: () => void;
  filterOptions: SkuFilterOptions;
  loading: boolean;
}

const SkuFiltersModal: React.FC<Props> = ({
  count,
  open,
  setOpen,
  onChange,
  onClearAll,
  filterOptions,
  loading,
}) => {
  const { selectedFilters } = useSkus();
  const selectedTotalFilters = selectedFilters
    ? Object.values(selectedFilters).filter((value) => value !== undefined).length
    : 0;

  return (
    <Modal setOpen={setOpen} open={open}>
      {selectedTotalFilters > 0 && <div className="display_flex" style={{ justifyContent: "flex-end" }}>
        <Button
          onClick={onClearAll}
          variant="principal"
          scale="small"
          className="m_b_xxl"
        >
          Limpiar Filtros
        </Button>
      </div>}
      <SkuInputFilters onChange={onChange} filterOptions={filterOptions} loading={loading} />
      <div style={{ paddingBottom: "7.5vh" }}>
        <Button
          className="w_100_per m_t_xl m_b_xxl"
          onClick={() => setOpen(false)}
          icon={<Search />}
        >
          Ver <b>{count}</b> moto{count !== 1 ? "s" : ""}
        </Button>
      </div>
    </Modal>
  );
};

export default SkuFiltersModal;
